<template>
  <div class="main-body">
    <div class="header" >入住老人</div>
    <div class="out">
      <div class="search2">

        <div style="float:right">

          <el-select v-model="governmentCode" placeholder="请选择政府"
                     @change="govChange"
                     style="margin-right:10px">
            <el-option
                v-for="item in governmentValue"
                :key="item.governmentCode"
                :label="item.name"
                :value="item.governmentCode">
            </el-option>
          </el-select>

          <el-select v-model="institutionCode" placeholder="请选择机构">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>
          <el-button size="mini" style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" v-loading="loading" border>

        <el-table-column prop="elderlyName" fixed label="姓名" width="100px"></el-table-column>

        <el-table-column prop="checkinSetmealName" label="护理套餐" width="120px"></el-table-column>
        <el-table-column prop="liveAddress" label="床位号" width="150px"></el-table-column>

        <el-table-column prop="priceMonth" label="月费用" width="120px"></el-table-column>
        <el-table-column prop="univalenceTrue" label="实际费用" width="120px"></el-table-column>

        <el-table-column prop="elderlyFund.balance" label="余额"></el-table-column>
        <el-table-column prop="elderlyFund.advance" label="预交金"></el-table-column>
        <el-table-column prop="elderlyFund.imprest" label="备用金"></el-table-column>

        <el-table-column prop="checkinType" label="入住类型" width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.checkinType == '1'" >院护</span>
            <span v-if="scope.row.checkinType == '2'" >家护</span>
            <span v-if="scope.row.checkinType == '3'" >日护</span>
            <span v-if="scope.row.checkinType == '4'" >综合护</span>
          </template>
        </el-table-column>

        <el-table-column label="状态" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.status == '1'" style="color:blue;">入住中</span>
            <span v-if="scope.row.status == '2'" style="color: gray;">已退住</span>
          </template>
        </el-table-column>

        <el-table-column prop="createTime" :formatter="timefilter" width="180" label="登记时间"></el-table-column>

      </el-table>

      <div class="page" >
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: "Page",
  data() {
    return {
      loading: true,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,
      th: 0,


      arr_ins:[],
      institutionCode: '',

      governmentValue: [],
      governmentCode: '',


    }
  },

  created() {

    this.getGovList();

    this.th = this.$store.state.tableHeight;
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  components: {

  },
  methods: {

    getGovList(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Government/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.governmentValue=response.data.data;

              if(this.governmentValue.length>0){
                this.governmentCode = this.governmentValue[0].governmentCode;
                this.getIns();
                this.getList();
              }

            } else if (response.data.error == 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },
    govChange(val){
      this.governmentCode = val;

      this.arr_ins = [];
      this.institutionCode = '';
      this.getIns();
    },


    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListByGovCode2",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: this.governmentCode,
          type:1,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    getList() {
      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Checkin/AdmPage",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          governmentCode: this.governmentCode,
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          institutionCode:this.institutionCode,
        }
      }).then((response) => {
        //console.log(response);
        this.loading = false;

        if (response.data.error == 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        } else if (response.data.error == 1) {
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    timefilter(row, column, cellValue){
      return timefilters(cellValue)
    },


  }
}
</script>

<style lang="scss" scoped>
.checkIn /deep/ .el-table__body tr.current-row>td {
  background-color: #409EFF;
  color:#fff;
}
.checkIn /deep/ .el-input.is-disabled .el-input__inner {
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  color: #000;
  cursor: not-allowed;
}
.item{
  padding: 0px 20px;
}
</style>
